(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    const mdcExpressToggle = (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.open || !details.classList.contains('mdc-pdp-express')) return;
    const template = details.querySelector('template[data-mdc-express-template]');
    if (!template) return;
    template.replaceWith(template.content.cloneNode(true));
  };
  document.addEventListener('toggle', mdcExpressToggle, true);
  document.querySelectorAll('details.mdc-pdp-express[open]').forEach((target) => mdcExpressToggle({ target }));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mdc-product-reference-links"] && !Shopify.designMode) return;
  try {
    class MdcProductReferenceLinks extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.openDimensions);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.openDimensions);
    }

    openDimensions = (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a[data-dimension-media]');
      if (!link?.dataset.dimensionMedia) return;
      const gallery = this.closest('.product-information')?.querySelector('media-gallery');
      const zoom = gallery?.querySelector('zoom-dialog[ref="zoomDialogComponent"]');
      const media = zoom?.refs?.media;
      if (!media || typeof gallery?.zoom !== 'function') return;
      const index = Array.from(media).findIndex((item) => {
        const mediaElement = item.matches('[data-media-id]') ? item : item.querySelector('[data-media-id]');
        return mediaElement?.dataset.mediaId === link.dataset.dimensionMedia;
      });
      if (index < 0) return;
      gallery.zoom(index, event);
      event.preventDefault();
    };
  }

  if (!customElements.get('mdc-product-reference-links')) {
    customElements.define('mdc-product-reference-links', MdcProductReferenceLinks);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mdc-product-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mdc-product-video')) {
    class MdcProductVideo extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('.mdc-product-video__toggle');
        this.scenes = [...this.querySelectorAll('[data-scene]')];
        this.sceneTimes = this.scenes.map((scene) => Number.parseFloat(scene.dataset.sceneTime));
        this.hasSceneTimes = this.sceneTimes.length > 0 && this.sceneTimes.every(Number.isFinite);
        this.errorMessage = this.querySelector('.mdc-product-video__error');
        if (!this.video || !this.toggle) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.systemPausePending = false;
        this.playPending = false;
        this.autoplayBlocked = false;
        this.failed = false;
        this.pendingScene = undefined;
        this.sceneSeekTarget = undefined;
        this.sceneLoadRequested = false;
        this.sceneReloaded ??= false;
        this.resumeAfterSceneReload = false;
        this.video.muted = true;
        this.video.controls = false;
        this.toggle.hidden = false;
        this.toggle.disabled = false;
        this.errorMessage.hidden = true;
        this.updateButton();
        this.updateScene();

        this.scenes.forEach((scene, index) => {
          scene.addEventListener('click', () => this.seekToScene(index), options);
        });

        this.toggle.addEventListener('click', () => {
          if (this.video.paused && !this.playPending) {
            this.manualPaused = false;
            this.autoplayBlocked = false;
            this.startPlayback(true);
          } else {
            this.manualPaused = true;
            this.pausePlayback();
          }
        }, options);

        this.video.addEventListener('play', () => this.updateButton(), options);
        this.video.addEventListener('pause', () => {
          if (this.systemPausePending) this.systemPausePending = false;
          else if (this.visible && !document.hidden) this.manualPaused = true;
          this.updateButton();
        }, options);
        this.video.addEventListener('timeupdate', () => this.updateScene(), options);
        this.video.addEventListener('loadedmetadata', () => this.configurePlayback(), options);
        ['loadeddata', 'progress', 'canplay', 'canplaythrough', 'durationchange'].forEach((event) => {
          this.video.addEventListener(event, () => this.applyPendingScene(), options);
        });
        this.video.addEventListener('seeked', () => {
          this.applyPendingScene(true);
          this.updateScene();
        }, options);
        this.video.addEventListener('error', () => {
          this.failed = true;
          this.toggle.disabled = true;
          this.scenes.forEach((scene) => { scene.disabled = true; });
          this.errorMessage.hidden = false;
          this.pausePlayback();
        }, options);

        if (this.video.readyState >= 1) this.configurePlayback();

        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        window.addEventListener('pagehide', () => this.pausePlayback(), options);
        window.addEventListener('pageshow', () => this.syncPlayback(), options);
        this.motion.addEventListener('change', () => this.syncPlayback(), options);
        navigator.connection?.addEventListener?.('change', () => this.syncPlayback(), options);
        this.observer = new IntersectionObserver((entries) => {
          this.visible = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.25);
          this.syncPlayback();
        }, { threshold: [0, 0.25] });
        this.observer.observe(this.video);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.video?.pause();
        this.controller = null;
        this.visible = false;
        this.pendingScene = undefined;
        this.sceneSeekTarget = undefined;
        this.resumeAfterSceneReload = false;
      }

      updateButton() {
        this.toggle.textContent = this.video.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
      }

      updateScene() {
        const active = this.hasSceneTimes
          ? this.sceneTimes.findLastIndex((time) => this.video.currentTime + 0.01 >= time)
          : Math.min(2, Math.floor(this.video.currentTime / (this.video.duration / 3 || 4)));
        this.scenes.forEach((scene, index) => {
          if (index === active) scene.setAttribute('aria-current', 'true');
          else scene.removeAttribute('aria-current');
        });
      }

      configurePlayback() {
        const duration = this.video.duration;
        if (!Number.isFinite(duration) || duration <= 0) return;
        const requestedRate = Number.parseFloat(this.dataset.playbackRate);
        this.video.playbackRate = Number.isFinite(requestedRate) && requestedRate > 0
          ? requestedRate : Math.min(4, Math.max(1, duration / 6));
        this.applyPendingScene();
      }

      seekToScene(index) {
        if (this.failed || !this.isConnected) return;
        this.pendingScene = index;
        if (this.video.readyState === 0 && !this.sceneLoadRequested) {
          this.sceneLoadRequested = true;
          this.video.load();
        }
        this.applyPendingScene();
      }

      applyPendingScene(seeked = false) {
        if (this.failed || !this.isConnected) return;
        const duration = this.video.duration;
        if (!Number.isFinite(duration) || duration <= 0) return;
        if (this.resumeAfterSceneReload && this.video.readyState >= 2 && !this.playPending) {
          this.resumeAfterSceneReload = false;
          this.startPlayback(true);
        }
        if (this.pendingScene === undefined) return;
        const sceneDuration = duration / 3;
        const target = Math.min(duration - 0.05, this.hasSceneTimes
          ? this.sceneTimes[this.pendingScene]
          : this.pendingScene * sceneDuration + Math.min(0.5, sceneDuration / 4));
        if (this.sceneSeekTarget !== undefined) {
          if (!seeked && this.video.seeking) return;
          const previousTarget = this.sceneSeekTarget;
          this.sceneSeekTarget = undefined;
          if (target === previousTarget) {
            if (Math.abs(this.video.currentTime - target) < 0.25) this.pendingScene = undefined;
            return;
          }
        }
        if (this.video.seeking) return;
        // Metadata and buffered data do not guarantee that the browser can seek yet.
        for (let range = 0; range < this.video.seekable.length; range += 1) {
          if (this.video.seekable.start(range) <= target && this.video.seekable.end(range) >= target) {
            if (Math.abs(this.video.currentTime - target) < 0.01) {
              this.pendingScene = undefined;
              this.updateScene();
              return;
            }
            this.sceneSeekTarget = target;
            this.video.currentTime = target;
            this.updateScene();
            return;
          }
        }
        const buffered = this.video.buffered;
        if (!this.sceneReloaded && buffered.length === 1 && buffered.start(0) <= 0.05 && buffered.end(0) >= duration - 0.05) {
          // One retry lets a fully cached video expose its seekable range.
          this.sceneReloaded = true;
          this.sceneLoadRequested = true;
          this.resumeAfterSceneReload = !this.video.paused || this.playPending;
          this.pausePlayback();
          this.video.load();
        }
      }

      canPlay(manual) {
        const connection = navigator.connection;
        const limitedConnection = connection?.saveData || ['slow-2g', '2g', '3g'].includes(connection?.effectiveType);
        return this.isConnected && this.visible && !document.hidden && !this.failed && !this.manualPaused &&
          (manual || (!this.motion.matches && !this.autoplayBlocked && !limitedConnection));
      }

      syncPlayback() {
        if (this.canPlay(false)) this.startPlayback(false);
        else this.pausePlayback();
      }

      pausePlayback() {
        if (!this.video.paused) {
          this.systemPausePending = true;
          this.video.pause();
        }
        this.updateButton();
      }

      async startPlayback(manual) {
        if (!this.canPlay(manual) || this.playPending || !this.video.paused) return;
        this.playPending = true;
        const connection = this.controller;
        try {
          await this.video.play();
          if (this.controller === connection && !this.canPlay(manual)) this.pausePlayback();
        } catch (error) {
          if (this.controller === connection && !(this.resumeAfterSceneReload && error.name === 'AbortError')) {
            this.autoplayBlocked = true;
          }
        } finally {
          if (this.controller === connection) {
            this.playPending = false;
            this.updateButton();
            if (this.resumeAfterSceneReload) this.applyPendingScene();
          }
        }
      }
    }
    customElements.define('mdc-product-video', MdcProductVideo);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["review"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mdc-product-review-line')) {
    customElements.define('mdc-product-review-line', class extends HTMLElement {
      connectedCallback() {
        const connect = () => {
          if (!this.isConnected || this.querySelector('a[data-review-label]')) return;
          const target = document.querySelector('.mdc-product-testimonial');
          const label = this.querySelector('[data-review-label]');
          if (!target || !label) return;
          if (!target.id) target.id = 'mdc-product-reviews';
          const link = document.createElement('a');
          link.className = label.className;
          link.dataset.reviewLabel = '';
          link.href = '#' + target.id;
          link.textContent = label.textContent;
          link.addEventListener('click', (event) => {
            if (!target.isConnected) return;
            event.preventDefault();
            target.scrollIntoView({
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
              block: 'start'
            });
          });
          label.replaceWith(link);
        };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', connect, { once: true });
        } else {
          connect();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["store-review"] && !Shopify.designMode) return;
  try {
    (()=>{const dialog=document.getElementById('mdc-reviews-dialog');if(!dialog||dialog.dataset.ready)return;dialog.dataset.ready='true';document.body.append(dialog);const list=dialog.querySelector('.mdc-reviews-list');const cards=[...list.querySelectorAll('.mdc-review-card')];const filter=dialog.querySelector('[data-reviews-filter]');const sort=dialog.querySelector('[data-reviews-sort]');let trigger;function update(){let count=0;cards.sort((a,b)=>sort.value==='new'?b.dataset.date.localeCompare(a.dataset.date):a.dataset.date.localeCompare(b.dataset.date)).forEach(card=>{card.hidden=filter.value!=='all'&&card.dataset.rating!==filter.value;if(!card.hidden)count++;list.append(card)});dialog.querySelector('[data-reviews-count]').textContent=count+' '+dialog.dataset.countLabel;document.querySelectorAll('[data-store-reviews-total]').forEach(total=>{total.textContent=String(cards.length)});}document.querySelectorAll('[data-reviews-open]').forEach(button=>button.addEventListener('click',()=>{trigger=button;dialog.showModal()}));dialog.querySelector('[data-reviews-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>trigger?.focus());dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close()});filter.addEventListener('change',update);sort.addEventListener('change',update);update();})();
  } catch(e) { console.error(e); }
})();

})();
